import { combineReducers } from "@reduxjs/toolkit";

import adminReducer from "./adminsSlice";
import authReducer from "./authSlice";
import availabilitiesReducer from "./availabilitiesSlice";
import bookingsReducer from "./bookingsSlice";
import categoriesReducer from "./categoriesSlice";
import categoryTemplatesReducer from "./categoryTemplatesSlice";
import currentStudioReducer from "./currentStudioSlice"
import dialogReducer from "./dialogSlice";
import drawerReducer from "./drawerSlice";
import employeesReducer from "./employeesSlice";
import emptyScreensReducer from "./emptyScreensSlice";
import modalReducer from "./modalSlice";
import restorePasswordReducer from "./passwordRestorationSlice"
import schedulesReducer from "./schedulesSlice";
import selectedStudioReducer from "./selectedStudioSlice";
import servicesReducer from "./servicesSlice";
import serviceTemplatesReducer from "./serviceTemplatesSlice";
import studiosReducer from "./studiosSlice";
import tableReducer from "./tableSlice";
import usersReducer from "./usersSlice";

const rootReducer = combineReducers({
  availability: availabilitiesReducer,
  passwordRestore: restorePasswordReducer,
  auth: authReducer,
  admins: adminReducer,
  studios: studiosReducer,
  services: servicesReducer,
  serviceTemplates: serviceTemplatesReducer,
  categories: categoriesReducer,
  categoryTemplates: categoryTemplatesReducer,
  schedules: schedulesReducer,
  employees: employeesReducer,
  bookings: bookingsReducer,
  users: usersReducer,
  drawer: drawerReducer,
  table: tableReducer,
  dialog: dialogReducer,
  modal: modalReducer,
  emptyScreens: emptyScreensReducer,
  currentStudio: currentStudioReducer,
  selectedStudio: selectedStudioReducer,
});

export default rootReducer;
